import styled from 'styled-components';

export const Container = styled.div`
	border: 1px solid #e6e8e8;
	border-radius: 0.25rem;
	height: 100%;
`;
